<div
	class="wordmark__container"
	[class.wordmark__container--clickable]="canUpload()"
	(click)="canUpload() ? onUploadImage() : null"
>
	@if (src()) {
		<img
			class="wordmark__image"
			[src]="src()"
			alt="Organization wordmark"
		/>
	} @else {
		<div class="wordmark__fallback">
			<tui-icon [icon]="icon()" />
		</div>
	}
</div>

@if (canUpload()) {
	<input
		#fileUploadInput
		class="wordmark__file-upload"
		name="wordmark"
		type="file"
		[disabled]="disabled()"
		[accept]="accept"
		[multiple]="false"
		(change)="onFileChange()"
	/>

	<button
		tuiButton
		size="xs"
		iconStart="@tui.upload"
		[disabled]="disabled()"
		appearance="outline"
		type="button"
		(click)="onUploadImage()"
	>
		{{ 'organization.action.upload-logo' | transloco }}
	</button>

	@if (src()) {
		<button
			tuiButton
			size="xs"
			iconStart="@tui.x"
			[disabled]="disabled()"
			appearance="ghost"
			type="button"
			(click)="onRemoveImage()"
		>
			{{ 'organization.action.remove-logo' | transloco }}
		</button>
	}
}
